import { Flex } from 'reflexbox';
import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 41px;
  width: 154px;
  justify-content: center;
  border: 1px solid ${colors.GreyLight};
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
`;

export const DialogWrapper = styled.div<{ expanded: boolean }>`
  width: ${({ expanded }) => (expanded ? '700px' : '450px')};

  @media (max-width: 768px) {
    width: 400px;
  }
  margin: 30px;
`;

export const Header = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 60px;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  margin-top: 30px;
  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const StyledList = styled.div<{ expanded: boolean }>`
  width: ${({ expanded }) => (expanded ? '64%' : '100%')};

  @media (max-width: 768px) {
    width: ${({ expanded }) => (expanded ? '45%' : '100%')};
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  height: 40px;
`;

export const ColorBox = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
`;

export const Label = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #525252;
`;

export const PickerWrapper = styled.div<{ visible: boolean }>`
  width: ${({ visible }) => (visible ? '32%' : '0%')};
  margin-left: 2%;
`;
